import React from 'react';
import { useSelector } from 'react-redux';
import {
    OptionContainer,
    AccountFieldTitle,
    AccountFieldAddress,
    OptionalLoadMoreView,
    OuterContainer,
    ImgDiv,
    LineSeparator,
    OptionAccountContainer,
} from './Details.styled';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import starimage from 'src/assets/images/Star.svg';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

export default function AccountPhysicianTemplate({
    option,
    data,
    fieldname,
    optionValue,
    showOptionLoader = false,
    onLoadMore,
    showLoadMore,
    physiciantype,
    nameWidth,
    addressWidth,
}) {
    const isAllNotRecentUsed =
        (data || []).filter((element) => !element.recentlyUsed).length === data.length;

    const { physicianDropdownZGSurgeryVisibility } = useSelector(
        (state) => state.loginReducer
    );

    let isLasOption = data?.length
        ? data[data.length - 1][optionValue] == option[optionValue]
        : false;
    const { t } = useTranslation();

    return (
        <>
            <OuterContainer isLoadMore={isLasOption} margin display="unset">
                {fieldname != 'account' &&
                option.physicianFirstName === 'Other' &&
                option.physicianLastName === 'Physician' ? null : (
                    <div style={{ display: 'block' }}>
                        <>
                            <OptionContainer className="account-physician-option-dt-mask schedule-surgery-account-physician-dt-mask" padding={'10px 10px 5px 10px'}>
                                <OptionAccountContainer>
                                    <AccountFieldTitle
                                        width={nameWidth ? nameWidth : '70%'}
                                        mobileWidth={
                                            nameWidth ? nameWidth : '70%'
                                        }
                                        iPadwidth={
                                            nameWidth ? nameWidth : '70%'
                                        }
                                    >
                                        {option?.accountName
                                            ? option.accountName
                                            : option?.physicianFirstName
                                            ? `${option?.physicianFirstName} ${option?.physicianLastName}`
                                            : option?.physicianDisplayName}{' '}
                                    </AccountFieldTitle>
                                    <AccountFieldTitle
                                        margin="0px 5px"
                                        fontFamily="AvenirNextWorld Italic"
                                    >
                                        {fieldname === 'account'
                                            ? accountNumberZeroTrimmer(
                                                  option.accountId || ''
                                              )
                                            : option.surgeonNumber}
                                        {physicianDropdownZGSurgeryVisibility ===
                                            'VISIBLE' &&
                                        fieldname === 'physician' ? (
                                            accountNumberZeroTrimmer(
                                                option?.physicianId || ''
                                            )
                                        ) : (
                                            <></>
                                        )}
                                    </AccountFieldTitle>
                                    <div>
                                        <AccountFieldAddress
                                            width={
                                                addressWidth
                                                    ? addressWidth
                                                    : '30vw'
                                            }
                                            iPadwidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '18vw'
                                            }
                                            mobileWidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '30vw'
                                            }
                                        >
                                            {option?.address?.city ||
                                                option.city}
                                            {option?.address?.city ||
                                            option.city
                                                ? ', '
                                                : ''}
                                            {option?.address?.state ||
                                                option.state}
                                        </AccountFieldAddress>
                                        <AccountFieldAddress margin="0px 8px">
                                            {option?.address?.city ||
                                            option.city ||
                                            option?.address?.state ||
                                            option.state
                                                ? '|'
                                                : ''}
                                        </AccountFieldAddress>
                                        <AccountFieldAddress
                                            width={
                                                addressWidth
                                                    ? addressWidth
                                                    : option.specialityDesc
                                                    ? '33vw'
                                                    : '35vw'
                                            }
                                            mobileWidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '32vw'
                                            }
                                            iPadwidth={
                                                addressWidth
                                                    ? addressWidth
                                                    : '15vw'
                                            }
                                        >
                                            {option?.address?.addressLine1 ||
                                                option.specialityDesc}
                                        </AccountFieldAddress>
                                    </div>
                                </OptionAccountContainer>
                                <ImgDiv>
                                    {option.isFavorite || option.favorite ? (
                                        <img src={starimage} />
                                    ) : null}
                                </ImgDiv>
                            </OptionContainer>
                        </>
                        <LineSeparator></LineSeparator>
                    </div>
                )}
                {physiciantype != 'favorites' && fieldname != 'account' ? (
                    <>
                        <>
                            {isLasOption && data.length != 0 && showLoadMore ? (
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    <OptionalLoadMoreView
                                        height={
                                            showOptionLoader ? '150px' : '200px'
                                        }
                                        // some space is left after grey message area
                                        margin={
                                            showOptionLoader
                                                ? '10px 0 0 0'
                                                : '-2px 0 -8px 0'
                                        }
                                    >
                                        {showOptionLoader ? (
                                            <>
                                                <Spinner
                                                    id="scheduleSurgery-accountPhysicianTemplate-loadMore-loadingSpinner"
                                                    animation="border"
                                                    variant="primary"
                                                    small={true}
                                                >
                                                    <p>
                                                        {t(
                                                            'scheduleSurgery.details.thisMayTakeAroundAMin'
                                                        )}
                                                    </p>
                                                </Spinner>
                                            </>
                                        ) : (
                                            <>
                                                {/* text in two lines */}
                                                {isAllNotRecentUsed ? (
                                                    <p
                                                        style={{
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {t(
                                                            'scheduleSurgery.details.notRecetPhysicianMSG'
                                                        )}
                                                        <br />
                                                        {t(
                                                            'scheduleSurgery.details.trySearchingByTypeMSG'
                                                        )}
                                                    </p>
                                                ) : null}
                                                <p>
                                                    {t(
                                                        'scheduleSurgery.details.cantFindWhoYou'
                                                    )}
                                                    <br />
                                                    {t(
                                                        'scheduleSurgery.details.areLookingFor'
                                                    )}
                                                </p>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onLoadMore(true);
                                                    }}
                                                >
                                                    {t(
                                                        'scheduleSurgery.details.loadAllPhysicians'
                                                    )}
                                                </button>
                                            </>
                                        )}
                                    </OptionalLoadMoreView>
                                </div>
                            ) : null}
                        </>
                    </>
                ) : null}
            </OuterContainer>
        </>
    );
}
